import { HATAG } from '@business/constants/helparticle';
import { AnalyticsModuleType, TagToAnalyticsModuleMap } from '@business/entities/analytics/AnalyticsRequest';
import { R } from '@core/utils/r';

export function getModuleName(tag: HATAG | string) {
  const moduleName = TagToAnalyticsModuleMap[tag] || TagToAnalyticsModuleMap[R.lowerCase(tag)] || TagToAnalyticsModuleMap[R.camelCase(tag)] || tag;
  return moduleName === 'support-tickets' ? AnalyticsModuleType.supportTickets : moduleName;
}
